import React from 'react';
import asyncComponent from '../../../util/asyncComponent';

import PrivateRoute from './PrivateRoute';
import { Route, Switch } from 'react-router-dom';

const Config = asyncComponent(() => import('../config'));

const ConfigGerais = asyncComponent(() => import('../config/gerais'));
const Integracoes = asyncComponent(() => import('../config/integracoes'));
const IntegracoesV2 = asyncComponent(() =>
  import('../config/integracoes v2')
);
const NiveisAcesso = asyncComponent(() => import('../config/niveis-acesso'));
const StatusProcesso = asyncComponent(() =>
  import('../config/status-processo')
);
const StatusOcorrencia = asyncComponent(() =>
  import('../config/status-ocorrencia')
);
const ClassificacaoTitulo = asyncComponent(() =>
  import('../config/classificacao-titulo')
);
const Email = asyncComponent(() => import('../config/email'));
const LayoutImportacao = asyncComponent(() =>
  import('../config/layout-importacao')
);
const LayoutHigienizacao = asyncComponent(() =>
  import('../config/layout-higienizacao')
);
const ControleDeAcessoIp = asyncComponent(() =>
  import('../config/controle-de-acesso-ip')
);
const ControleDeAcessoHorarios = asyncComponent(() =>
  import('../config/controle-de-acesso-horarios')
);
const PoliticaDeSenhas = asyncComponent(() =>
  import('../config/politicas-de-senha')
);
const LDAP = asyncComponent(() => import('../config/ldap'));
const Automacoes = asyncComponent(() => import('../config/automacoes'));
const TreinamentoSuporte = asyncComponent(() =>
  import('../diversos/WhatsApp/training')
);

const Produtos = asyncComponent(() => import('../config/produtos'));
const Marketplace = asyncComponent(() => import('../config/marketplace'));
const MarketplaceSMS = asyncComponent(() =>
  import('../config/marketplace/sms')
);
const MarketplaceHigienizacao = asyncComponent(() =>
  import('../config/marketplace/higienizacao')
);

export default function ConfigRoutes({ match }) {
  return (
    <>
      <Switch>
        <PrivateRoute
          path={`${match.url}/config/treinamento`}
          component={TreinamentoSuporte}
          codigo="modulo_configuracoes"
        />

        <PrivateRoute
          path={`${match.url}/config/gerais`}
          component={ConfigGerais}
          codigo="conf_gerais"
        />
        <PrivateRoute
          path={`${match.url}/config/integracoes-v2`}
          component={IntegracoesV2}
          codigo="conf_gerais"
        />
        <PrivateRoute
          path={`${match.url}/config/integracoes`}
          component={Integracoes}
          codigo="conf_gerais"
        />
        <PrivateRoute
          path={`${match.url}/config/niveis-acesso`}
          component={NiveisAcesso}
          codigo="conf_niveis"
        />
        <PrivateRoute
          path={`${match.url}/config/status-processo`}
          component={StatusProcesso}
          codigo="conf_status_proc"
        />
        <PrivateRoute
          path={`${match.url}/config/status-ocorrencia`}
          component={StatusOcorrencia}
          codigo="conf_status_hist"
        />
        <PrivateRoute
          path={`${match.url}/config/classificacao-titulo`}
          component={ClassificacaoTitulo}
          codigo="conf_status_hist"
        />
        <PrivateRoute
          path={`${match.url}/config/controle-de-acesso-ip`}
          component={ControleDeAcessoIp}
          codigo="conf_ip_liberado"
        />
        <PrivateRoute
          path={`${match.url}/config/controle-de-acesso-horarios`}
          component={ControleDeAcessoHorarios}
          codigo="conf_horario_acesso"
        />
        <PrivateRoute
          path={`${match.url}/config/politicas-de-senha`}
          component={PoliticaDeSenhas}
          codigo="conf_politica_de_senhas"
        />
        <Route
          path={`${match.url}/config/ldap`}
          component={LDAP}
          //codigo="conf_politica_de_senhas"
        />
        <PrivateRoute
          path={`${match.url}/config/email`}
          component={Email}
          codigo="conf_emails"
        />
        <PrivateRoute
          path={`${match.url}/config/layout-importacao`}
          component={LayoutImportacao}
          codigo="conf_layouts_imp"
        />
        <PrivateRoute
          path={`${match.url}/config/layout-higienizacao`}
          component={LayoutHigienizacao}
          codigo="conf_layouts_hig"
        />
        <PrivateRoute
          path={`${match.url}/config/produtos`}
          component={Produtos}
          codigo="modulo_configuracoes"
        />

        <PrivateRoute
          path={`${match.url}/config/marketplace/sms`}
          component={MarketplaceSMS}
          codigo="modulo_configuracoes"
        />
        <PrivateRoute
          path={`${match.url}/config/marketplace/higienizacao`}
          component={MarketplaceHigienizacao}
          codigo="modulo_configuracoes"
        />
        <PrivateRoute
          path={`${match.url}/config/marketplace`}
          component={Marketplace}
          codigo="modulo_configuracoes"
        />

        <PrivateRoute
          path={`${match.url}/config/automacoes`}
          component={Automacoes}
          codigo="modulo_configuracoes"
        />
        <PrivateRoute
          path={`${match.url}/config/inicio`}
          component={Config}
          codigo="modulo_configuracoes"
        />
        <PrivateRoute
          exact
          path={`${match.url}/config`}
          component={Config}
          codigo="modulo_configuracoes"
        />
      </Switch>
    </>
  );
}
